import { NgClass } from '@angular/common';
import { Component, computed, inject, input, InputSignal } from '@angular/core';
import { ToolsService } from 'src/app/services/tools.service';
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'app-chatbot-custom-route-desktop',
  standalone: true,
  imports: [
    NgClass,
    NewChatBotComponent
  ],
  templateUrl: './chatbot-custom-route-desktop.component.html',
  styleUrls: ['./chatbot-custom-route-desktop.component.scss'],
})
export class ChatbotCustomRouteDesktopComponent  {
  public chatID: InputSignal<string> = input.required<string>();  
  public dataChatService = inject(DataChatService)
  public isFullScreen = computed(() => this.dataChatService.isFullScreen())
  public isStreaming = computed(() => this.dataChatService.isStreaming())

  public microIsActive = computed(() => this.dataChatService.microIsActive())

  public timeout: any;
  constructor(public tools: ToolsService) {}

  toggleChatView(){
      this.dataChatService.hideChat.update(prev => !prev)
  }
}
